export { default as CustomHead } from './CustomHead';
